import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "survey-relationships" }
const _hoisted_2 = { class: "survey-relationships__header" }
const _hoisted_3 = { class: "survey-relationships__description" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "survey-relationships__row-header" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "survey-relationships__device-column" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "survey-relationships__column-header" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_11 = { class: "survey-relationships__row-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_h1 = _resolveComponent("n-h1")!
  const _component_n_checkbox = _resolveComponent("n-checkbox")!
  const _component_n_checkbox_group = _resolveComponent("n-checkbox-group")!
  const _component_n_table = _resolveComponent("n-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_n_h1, null, {
        default: _withCtx(() => [
          _createTextVNode("Relationships")
        ]),
        _: 1
      }),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.text), 1)
    ]),
    _createElementVNode("div", null, [
      (_ctx.laptop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_n_table, { bordered: true }, {
              default: _withCtx(() => [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yourNetwork, (person, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("th", _hoisted_5, [
                        _createTextVNode(_toDisplayString(`${person.name}, ${person.organization} `) + " ", 1),
                        _hoisted_6,
                        _createElementVNode("div", _hoisted_7, [
                          (person.relationshipKeys)
                            ? (_openBlock(), _createBlock(_component_n_checkbox_group, {
                                key: 0,
                                value: person.relationshipKeys,
                                "onUpdate:value": ($event: any) => ((person.relationshipKeys) = $event)
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                                    return (_openBlock(), _createBlock(_component_n_checkbox, {
                                      key: option.key,
                                      value: option.key,
                                      "onUpdate:value": ($event: any) => ((option.key) = $event),
                                      label: `${option.label}`
                                    }, null, 8, ["value", "onUpdate:value", "label"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["value", "onUpdate:value"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_n_table, { bordered: true }, {
              default: _withCtx(() => [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_9, [
                    _hoisted_10,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                      return (_openBlock(), _createElementBlock("th", {
                        class: "survey-relationships__column-label",
                        key: option.key
                      }, _toDisplayString(option.label), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yourNetwork, (person, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("th", _hoisted_11, _toDisplayString(`${person.name.trim().length > 0 ? `${person.name},` : ''} ${person.organization} `), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                        return (_openBlock(), _createElementBlock("td", {
                          class: "survey-relationships__column-checkbox",
                          key: option.key
                        }, [
                          (person.relationshipKeys)
                            ? (_openBlock(), _createBlock(_component_n_checkbox_group, {
                                key: 0,
                                value: person.relationshipKeys,
                                "onUpdate:value": ($event: any) => ((person.relationshipKeys) = $event)
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_n_checkbox, {
                                    value: option.key,
                                    "onUpdate:value": ($event: any) => ((option.key) = $event)
                                  }, null, 8, ["value", "onUpdate:value"])
                                ]),
                                _: 2
                              }, 1032, ["value", "onUpdate:value"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]))
    ])
  ]))
}